export const API_ENDPOINT_UPLOAD_FILE = `${process.env.REACT_APP_API_URL}/storage/objects/upload/azure`//new
export const API_ENDPOINT_FIELDNAME = `${process.env.REACT_APP_API_URL}/agTable/csvFieldCheck`